import { useState, useSyncExternalStore } from "react";
import { useLocation } from "react-router";

import { markUpdatesSeen } from "~/feature/getUpdates/utils/getUpdatesStorage";

const EVENT_ROUTE_PREFIX = "/event/";
const CALCULATOR_DOCK_SELECTOR = '[data-bottom-dock="market-calculator"]';

const subscribeToBodyMutations = (onStoreChange: () => void) => {
  const observer = new MutationObserver(onStoreChange);
  observer.observe(document.body, { childList: true, subtree: true });

  return () => observer.disconnect();
};

const subscribeToNothing = () => () => undefined;

const hasCalculatorDock = () =>
  Boolean(document.querySelector(CALCULATOR_DOCK_SELECTOR));

const getServerSnapshot = () => false;

export const useGetUpdatesCta = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const isEventPage = pathname.startsWith(EVENT_ROUTE_PREFIX);

  const raised = useSyncExternalStore(
    isEventPage ? subscribeToBodyMutations : subscribeToNothing,
    isEventPage ? hasCalculatorDock : getServerSnapshot,
    getServerSnapshot
  );

  const handleOpen = () => {
    setOpen(true);
    markUpdatesSeen();
  };

  const handleClose = () => setOpen(false);

  return { open, raised, handleOpen, handleClose };
};
